module.exports = __webpack_public_path__ + "static/media/aw.c7cc0c4c.svg";